import { render, staticRenderFns } from "./feature.vue?vue&type=template&id=dc15d10c&scoped=true&"
import script from "./feature.vue?vue&type=script&lang=js&"
export * from "./feature.vue?vue&type=script&lang=js&"
import style0 from "./feature.vue?vue&type=style&index=0&id=dc15d10c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc15d10c",
  null
  
)

component.options.__file = "feature.vue"
export default component.exports